import format from "date-fns/format";
import React, { useEffect } from "react";
import { HiOutlineDocumentText } from "react-icons/hi";
import { TbTicket } from "react-icons/tb";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import useMethodAccount from "../hooks/useMethodAccount";
import "./style.scss";
import getId from "../../../../utils/getId";
import { BiCommentError } from "react-icons/bi";
import { useTranslation } from "react-i18next";

const AccountDocuments: React.FC = () => {
  const logoUrl = useSelector((state: State) => state.config.facilityLogoUrl);
  const { t } = useTranslation();

  const { getUserDocuments, docs, getBoughtTickets, getDownloadDocument } = useMethodAccount();

  useEffect(() => {
    getUserDocuments();
  }, []);
  return (
    <React.Fragment>
      <div className="account-documents">
        <h3 className="ticket-title flex-start-center">
          {" "}
          <HiOutlineDocumentText className="icon" />
          {t("twoje_dokumenty")}
        </h3>

        <div className="flex-start-center flex-wrap">
          {docs.length > 0 ? (
            <React.Fragment>
              {docs.map((item, index) => (
                <div className={"account-documents-single border shadow flex-between-center"} key={index}>
                  <img className="logo-document" src={logoUrl} alt="Logo dokumenty" />

                  <div className="flex-column account-column ">
                    {item.paymentStatus === "R" && <b>{t("zwrocony")}</b>}

                    <b>{item.documentNumber}</b>
                    <span>{t("numer_zamowienia")}</span>
                  </div>

                  <div className="flex-column account-column">
                    <b>{format(item.paymentDate, "dd.MM.yyyy")}</b>
                    <span>{t("data_zamowienia")}</span>

                    <strong>
                      {t("kwota")}: {item.total} {t("zl")}
                    </strong>
                  </div>

                  <div className="buttons flex-column">
                    {item.hasTickets && (
                      <button
                        onClick={() => getBoughtTickets(getId(item))}
                        className="button padding-medium medium button-fill-main"
                      >
                        <TbTicket className="icon" />
                        {t("pobierz_bilety")}
                      </button>
                    )}

                    <button
                      onClick={() => getDownloadDocument(getId(item))}
                      className="button padding-medium medium button-text-main"
                    >
                      <HiOutlineDocumentText className="icon" />
                      {t("pobierz_dokument")}
                    </button>
                  </div>
                </div>
              ))}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="alert alert-yellow">
                <BiCommentError className="alert-icon" />
                <b>{t("brak_dokumentow")}</b>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AccountDocuments;
